<div class="login-box" style="background-color: #753CFD;" *ngIf="viewNumber == 1">    

    <div class="font-h2 text-white text-center p-20" style="padding-bottom: 0px;">¡Boom!</div>

    <div class="p-40" style="padding-top: 0px;">
        <!-- overview -->
        <div class="login-box bg-white w-100 p-20" style="box-shadow: 4px 4px 4px 1px #562fb1;">
            <div class="d-flex-center" *ngIf="isCoupon">
                <div class="w-100">
                    <div class="img-container">
                        <div class="img-bg d-flex-center" [ngStyle]="{'height': couponApplicationType == 2 ? '55px' : '85px'}">
                                <!-- Hide GiviBITFormat3 when applicationType is different of Experiences-->
                                <img src="assets/images/GiviBITFormat3.png" style="height: 100%;" *ngIf="couponApplicationType == 1">
                                <img  src="{{productImage}}" alt="Carga tu foto aquí" class="img-coupon"/>
                        </div>
                    </div>
                </div> 
            </div>
            <div class="d-flex-center" *ngIf="!isCoupon">
                <img src="{{productImage}}" style="max-width: 300px; max-height: 135px;"/>
            </div>
            <div class="text-center m-t-10 m-b-10">
                <i class="mdi mdi-chevron-double-down" style="font-size: 30px;"></i>
            </div>
            <div class="d-flex-center">
                <img src="assets/images/billetera.png" style="width: 135px;">
            </div>
            <div class="font-c1 text-muted text-center">Mis Givis</div>
        </div>
        <!-- assignedGivi -->
        <div class="font-h3 text-white">Givi Asignado</div>
        <div class="custom-text">Podés ver o utilizar tu Givi ingresá a tu cuenta desde el app o desde la versión Web.</div>

        <div class="m-t-20">
            <div class="d-flex-between align-items-center" >
                <div class="font-b1 text-white  cursor-pointer" (click)="onNextView()">Siguiente</div>
                <div class="cursor-pointer" (click)="onNextView()">
                    <img src="assets/images/arrowAssign.png" width="70px">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="login-box" *ngIf="viewNumber == 2">
    <div class="p-20">
        <div class="font-h3 text-center p-20" style="padding-top: 0px;">Ver "Mis Givis"</div>
        <div class="m-t-20">
            <div class="d-flex-center">
                <a href="https://giviapp.com" target="_blank" class="download">
                    <img src="assets/images/iosAssign.png" style="width: 180px;">
                </a>
            </div>
            <div class="d-flex-center m-t-20">
                <a href="https://giviapp.com" target="_blank" class="download">
                    <img src="assets/images/androidAssign.png" style="width: 180px;">
                </a>
            </div>
        </div>
        <div class="m-t-40">
            <div class="font-b1 text-center" style="font-weight: 400;">Abrir desde el navegador</div>
            <div class="go-background cursor-pointer" (click)="openGiviWeb()">
                <div class="row" st>
                    <div class="col-8">
                        <div class="font-c1 text-white">www.migivi.com</div>
                        <div class="font-h4 text-white">Navegador</div>
                    </div>
                    <div class="col-4 d-flex-end align-items-center">
                        <div class="go">
                            <i class="mdi mdi-arrow-right-top" style="font-size: 30px;"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
    <div class="">
        <img src="assets/images/giviAssigned.png" class="w-60">
    </div>
</div>

<!-- Unused modal -->
<ng-template #assignedModal let-modal>
    <div class="modal-body">   
        <div class="font-h5 text-center m-b-20">¡Boom! Givi Asignado</div>
        <div class="d-flex-center" *ngIf="isCoupon">
            <div class="w-100">
                <div class="img-container">
                    <div class="img-bg d-flex-center" [ngStyle]="{'height': couponApplicationType == 2 ? '78px' : '110px'}">
                        <!-- Hide GiviBITFormat3 when applicationType is different of Experiences-->
                        <img src="assets/images/GiviBITFormat3.png" style="height: 100%;" *ngIf="couponApplicationType == 1">
                        <img  src="{{productImage}}" alt="Carga tu foto aquí" class="img-coupon"/>
                    </div>
                </div>
            </div> 
        </div>
        <div class="d-flex-center" *ngIf="!isCoupon">
            <img  src="{{productImage}}" alt="Carga tu foto aquí" style="max-width: 300px;"/>
        </div>
        <div class="text-center m-t-10 m-b-10">
            <i class="mdi mdi-chevron-double-down" style="font-size: 30px;"></i>
        </div>
        <div class="d-flex-center">
            <img src="assets/images/billetera.png" style="max-width: 320px;">
        </div>
        <div class="font-c1 text-center">Mis Givis</div>
        <div class="m-t-20 d-flex-center">
            <button class="btn btn-primary mr-2" style="width: 211px;" (click)="openGivi()">Ir al app móvil</button>
            <button class="btn btn-primary" style="width: 211px;" (click)="openGiviWeb()">Ir al app web</button>
        </div>
        <div class=" d-flex-center">
            <span class="text-c2 text-muted">Ingresá al app móvil si ya descargaste Givi </span>
        </div>
        <!-- <div class="font-b2 text-primary text-center m-t-20 cursor-pointer" style="text-decoration: underline;" (click)="openGivi()">Ingresá para ver tu givi</div> -->
    </div>
</ng-template>

